import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import MainLayout from './components/layout/MainLayout';
import DashboardPage from './pages/DashboardPage';
import VideosPage from './pages/VideosPage';
import ParametresPage from './pages/ParametresPage';
import AffichesPage from './pages/AffichesPage';
import RepresentationsPage from './pages/RepresentationsPage';
import CanauxPage from './pages/CanauxPage';
import PagesPage from './pages/PagesPage';
import CategoriesPage from './pages/CategoriesPage';
import MediaLibraryPage from './pages/MediaLibraryPage';
import UsersPage from './pages/UsersPage';
import ContactMessagesPage from './pages/ContactMessagesPage';
import BroadcastsPage from './pages/BroadcastsPage';
import PrayerCentersPage from './pages/PrayerCentersPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="broadcasts" element={<BroadcastsPage />} />
            <Route path="parametres" element={<ParametresPage />} />
            <Route path="affiches" element={<AffichesPage />} />
            <Route path="representations" element={<RepresentationsPage />} />
            <Route path="prayer-centers" element={<PrayerCentersPage />} />
            <Route path="canaux" element={<CanauxPage />} />
            <Route path="pages" element={<PagesPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="media" element={<MediaLibraryPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="contact-messages" element={<ContactMessagesPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
